module.exports = __webpack_public_path__ + "0ae8e041cd56deebad2ebd22a244eee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiexietexing.png
// module id = 174
// module chunks = 1